import { Navigate } from "react-router-dom";
import useDecodedToken from "../utils/useDecodedToken";

// Guards a whole route: useDecodedToken() already redirects to the BattleNet
// login when the user isn't logged in, so this only needs to additionally
// check the admin role.
const AdminRoute = ({ children }) => {
  const { decodedJwt } = useDecodedToken();

  if (!decodedJwt) {
    return null;
  }

  if (decodedJwt.role !== "admin") {
    return <Navigate to="/" replace />;
  }

  return children;
};

export default AdminRoute;
